import { AlertActionTypes } from 'util/modules/Alert/redux/types'
import { PaginationOpts } from 'util/types/index'
/**
* Data Types
*/

export interface Notification {
  id: number,
  title: string,
  message: string,
  action: string,
  payload: Record<string, number>,
  quantitySend: number,
  quantityOpen: number,
  quantitySms: number,
  createdAt: string,
  updatedAt?: string
}

/**
* State Type
*/

export interface NotificationState {
  readonly notification?: Notification
  readonly notifications: { items: Notification[], pagination?: PaginationOpts }
}

/**
* Action Enum Types
*/

export enum NotificationTypes {
  NOTIFICATION_CREATE = 'NOTIFICATION/CREATE',
  NOTIFICATION_UPDATE = 'NOTIFICATION/UPDATE',
  NOTIFICATION_DELETE = 'NOTIFICATION/DELETE',
  NOTIFICATION_GET = 'NOTIFICATION/GET',
  NOTIFICATION_GET_LIST = 'NOTIFICATION/GET/LIST',
}

/**
* Action Types
*/
interface CreateAction {
  type: typeof NotificationTypes.NOTIFICATION_CREATE,
  payload: Notification
}

interface UpdatetAction {
  type: typeof NotificationTypes.NOTIFICATION_UPDATE,
  payload: Notification
}

interface DeleteAction {
  type: typeof NotificationTypes.NOTIFICATION_DELETE,
  payload: number
}

interface GetAction {
  type: typeof NotificationTypes.NOTIFICATION_GET,
  payload: Notification
}

interface GetListAction {
  type: typeof NotificationTypes.NOTIFICATION_GET_LIST,
  payload: Notification[],
  pagination?: PaginationOpts
}

export type NotificationActionTypes = (
  AlertActionTypes | CreateAction | UpdatetAction | DeleteAction | GetAction | GetListAction
)
